import * as React from 'react'

import styles from './DiscountBadge.module.css'

type DiscountBadgeProps = {
  discountPercent: string
}

const DiscountBadge: React.FC<DiscountBadgeProps> = ({ discountPercent }) => (
  <div className={styles.discountBadgeContainer}>{discountPercent}</div>
)

export default DiscountBadge
